import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeAlertsInitialState, handlePaginationState, handleFiltersState } from "../../../store/alerts/alertsSlice";

const mapStateToProps = (state) => {
    return {
        showDrawer: state.alerts?.showDrawer,
        formType: state.alerts?.formType,
        initialValues: state.alerts?.initialValues,
        pagination: state.alerts?.pagination,
        filters: state.alerts?.filters,
    };
};

const mapDispatch = {
    changeAlertsInitialState,
    handlePaginationState,
    handleFiltersState,
};

const mapDispatchToProps = (dispatch) => bindActionCreators(mapDispatch, dispatch);

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
